import { useState, useEffect } from "react";
import { getTopStoriesAsideWidget } from "../api/widgets/topStories/requests";

function useStoryblokTopStoriesAsideWidget() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getTopStoriesAsideWidget()
      .then(data => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokTopStoriesAsideWidget };
